import { render, staticRenderFns } from "./ImportPage.vue?vue&type=template&id=9121ffaa&"
import script from "./ImportPage.vue?vue&type=script&lang=js&"
export * from "./ImportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports